module.exports = __webpack_public_path__ + "img/dele.04f7e823.svg";